// ScrollMagic and GSAP are loaded from CDN via WordPress wp_enqueue_script
/* global ScrollMagic */
export const sceneController = new ScrollMagic.Controller();

export const getSceneDuration = function getSceneDuration() {
    return Math.round((window.innerHeight + this.offsetHeight) / 2);
};
